import { setDefaultStyle, strokeWidth } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P, Segments } from "apparatus/library/common";
import { Group, Path } from "paper";
export class Tweezers {
    render(appearance) {
        if (appearance.style == "3d") {
            return render3d(appearance);
        }
        else {
            return renderSimple(appearance);
        }
    }
}
Tweezers.properties = {
    label: "Tweezers",
    flippable: true,
    defaultAppearance: {
        style: "3d",
        opening: 0.5
    },
    appearanceSpecs: [
        {
            spec: "radio", key: "style", label: "Style",
            options: [
                { value: "3d", label: "Default" },
                { value: "simple", label: "Simple" },
            ],
        },
        {
            spec: "slider", key: "opening", label: "Opening",
            min: 0.0, max: 1.0, step: 0.1,
        },
    ],
};
function render3d(appearance) {
    const top = new Path(Segments([[0, 0]], [[16, -9], [-10, 2], [10, -2]], [[40, -8], [-3, 2]], [[45, -11]], [[154, -10], , [9, 0]], [[155, 1], [8, 0]], [[44, -2], , [-10, 0]], [[17, -5], [10, 0], [-7, 0]]));
    top.closePath();
    const bottom = top.clone();
    top.withGradientFill("right", Gradients.cylinder("#aaaaaa".color(), 5))
        .withStroke(strokeWidth("thinner"), "#999999");
    bottom.fillColor = "#666666";
    bottom.shear(-0.08 * appearance.opening, P(155, -5));
    const graphic = new Group([bottom, top]);
    return {
        graphic: graphic,
        hitShape: graphic.bounds.expand(10).toShape()
    };
}
function renderSimple(appearance) {
    const oneSide = new Path(Segments([[-120, 0], , [5, -13]], [[0, 0], [-120, -7]]));
    const otherSide = oneSide.clone();
    const pivot = P(0, 0);
    otherSide.scale(1.0, -1.0, pivot);
    const angle = 5 * appearance.opening + 1;
    oneSide.rotate(angle, P(0, 0));
    otherSide.rotate(-angle, pivot);
    const graphic = new Group([oneSide, otherSide]);
    setDefaultStyle(graphic);
    return {
        graphic: graphic,
        hitShape: graphic.bounds.expand(10).toShape()
    };
}
